var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarCommunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 3.95703H10.1875V1.75C10.1875 1.4043 9.9082 1.125 9.5625 1.125H1.59375V0.34375C1.59375 0.257812 1.52344 0.1875 1.4375 0.1875H0.34375C0.257812 0.1875 0.1875 0.257812 0.1875 0.34375V15.6562C0.1875 15.7422 0.257812 15.8125 0.34375 15.8125H1.4375C1.52344 15.8125 1.59375 15.7422 1.59375 15.6562V10.5H6.4375V12.707C6.4375 13.0527 6.7168 13.332 7.0625 13.332H15.1875C15.5332 13.332 15.8125 13.0527 15.8125 12.707V4.58203C15.8125 4.23633 15.5332 3.95703 15.1875 3.95703Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCommunity);
export default __webpack_public_path__ + "static/media/sidebar-community.171297851fef764dca8e1c20bcc3967f.svg";
export { ForwardRef as ReactComponent };